export default __webpack_public_path__ + "static/media/port.9e87550f.png";